// extracted by mini-css-extract-plugin
module.exports = {"nav":"AcquistiOnlineSidebar_nav__seVqU","rotation":"AcquistiOnlineSidebar_rotation__xmnJi"};